import { backofficeFetch } from '@/services/backoffice-api';
import type {
  BackofficeInterviewDetailResponse,
  BackofficeParticipantDetailsResponse,
} from './types';

export async function fetchBackofficeInterviewDetail(
  interviewId: string,
  signal?: AbortSignal
): Promise<BackofficeInterviewDetailResponse> {
  const init: RequestInit = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  };

  if (signal) {
    init.signal = signal;
  }

  const response = await backofficeFetch(`/interviews/${encodeURIComponent(interviewId)}`, init);

  if (!response.ok) {
    throw new Error(`Failed to load interview (${response.status})`);
  }

  return (await response.json()) as BackofficeInterviewDetailResponse;
}

export async function fetchBackofficeParticipantDetails(
  interviewId: string,
  signal?: AbortSignal
): Promise<BackofficeParticipantDetailsResponse> {
  const init: RequestInit = { method: 'GET', headers: { Accept: 'application/json' } };
  if (signal) {
    init.signal = signal;
  }
  const response = await backofficeFetch(
    `/interviews/${encodeURIComponent(interviewId)}/participant-details`,
    init
  );

  if (!response.ok) {
    throw new Error(`Failed to load participant details (${response.status})`);
  }

  return (await response.json()) as BackofficeParticipantDetailsResponse;
}
